module.exports = __webpack_public_path__ + "img/sixpackcarrier18.afb2e229.jpg";